import styled from 'styled-components'

export const PaginationPageNumber = styled.div`
  height: 32px;
  width: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${(p) => {
    return p.isSelected ? 'rgba(255, 255, 255, 1)' : 'rgba(32, 32, 32, 0.5)'
  }};
  background: ${(p) => {
    return p.isSelected ? 'rgba(10, 161, 244, 1)' : 'rgba(255, 255, 255, 1)'
  }};
  border-radius: 50%;
  margin-left:8px;
  cursor: pointer;
  user-select: none;
  
  :hover {
    color: ${(p) => {
    return p.isSelected ? 'rgba(255, 255, 255, 1)' : 'rgba(32, 32, 32, 1)'
  }};
    background: ${(p) => {
    return p.isSelected ? 'rgba(10, 161, 244, 1)' : 'rgba(32, 32, 32, 0.05)'
  }};
  }
`

export const PaginationIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  width: 32px;
  border-radius: 50%;
  margin-left: 8px;
  color: rgba(32, 32, 32, 0.5);
  cursor: pointer;
  user-select: none;

  &:hover svg path{
    fill-opacity: ${(p) => {
    return p.disabled ? '0.5' : '1'
  }};
  }
  
  :hover {
    color: rgba(32, 32, 32, 1);    
    background: ${(p) => {
    return p.disabled ? 'rgba(255, 255, 255, 1)' : 'rgba(32, 32, 32, 0.05)'
  }};
  }  
`

export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

